import { Bug, HelpCircle, Lightbulb, Palette, Zap } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { FeedbackType } from '@/shared/domain'

export type FeedbackTypeConfig = {
  value: FeedbackType
  label: string
  Icon: LucideIcon
  activeClass: string
}

export const FEEDBACK_TYPE_CONFIG: FeedbackTypeConfig[] = [
  { value: 'bug', label: 'Bug', Icon: Bug, activeClass: 'data-[state=on]:border-destructive data-[state=on]:bg-destructive/10 data-[state=on]:text-destructive' },
  { value: 'idea', label: 'Idea', Icon: Lightbulb, activeClass: 'data-[state=on]:border-amber data-[state=on]:bg-amber-soft data-[state=on]:text-amber' },
  { value: 'ui-ux', label: 'UI/UX', Icon: Palette, activeClass: 'data-[state=on]:border-steel data-[state=on]:bg-steel-soft data-[state=on]:text-steel' },
  { value: 'performance', label: 'Performance', Icon: Zap, activeClass: 'data-[state=on]:border-sage data-[state=on]:bg-sage-soft data-[state=on]:text-sage' },
  { value: 'other', label: 'Other', Icon: HelpCircle, activeClass: 'data-[state=on]:border-border-strong data-[state=on]:bg-muted data-[state=on]:text-muted-foreground' },
]

export const FEEDBACK_TYPE_CONFIG_BY_VALUE: Record<FeedbackType, FeedbackTypeConfig> =
  FEEDBACK_TYPE_CONFIG.reduce(
    (acc, config) => {
      acc[config.value] = config
      return acc
    },
    {} as Record<FeedbackType, FeedbackTypeConfig>,
  )

export function feedbackTypeLabel(type: FeedbackType): string {
  return FEEDBACK_TYPE_CONFIG_BY_VALUE[type].label
}
